import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  Flex,
  Image,
  Select,
  useToast,
  Text,
  Box,
  ButtonGroup,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Notification from "../../services/Notification";

export default function TestModal({
  isOpen,
  onClose,
  emailVariables,
  templateId,
  // appNotificationId,
  whatsappVariables,
  whatsappImageUrl,
  type,
}: any) {
  const initialRef = React.useRef(null);
  //   const email = localStorage.getItem("logged_in_email");

  const toast = useToast();

  const [filename, setFilename] = useState("");

  const [selectedOption, setSelectedOption] = useState<any>(null);

  //   const testids = [
  //     "8merwrSzZjRS9fEZWhmVjLY6fuk2", // singhayush28321@gmail.com
  //     "mR4bL1kCOOQ4qKbK5rlNNuSXXmd2", // abhishek@manoshala.com
  //     // "wdUXzFuNwVOwPOEPuMypvakfrxE2", // kratika@manoshala.com
  //     "u1AJIUq2hbYtGvIu04AgSbPGRiD2", // abhisheksw4@gmail.com
  //     "LBtD4WltjQd7Z6G8tENOJDwMiK02", // kratikaagarwal1@gmail.com
  //     "gOiHHnBePCXIKIV8IBtNUClNN8H3", // nish1997ns@gmail.com
  //   ];

  const [customInput, setCustomInput] = useState({
    userId: "",
    appUserId: "",
    phoneNumber: "",
  });

  const emailOptions = [
    {
      label: "Kratika Agrawal",
      userId: "kratika@manoshala.com",
      appUserId: "wdUXzFuNwVOwPOEPuMypvakfrxE2",
      phoneNumber: "7607471747",
    },
    {
      label: "Abhishek Kumar",
      userId: "abhishek@manoshala.com",
      appUserId: "mR4bL1kCOOQ4qKbK5rlNNuSXXmd2",
      phoneNumber: "",
    },
    {
      label: "Ayush Singh",
      userId: "singhayush28321@gmail.com",
      appUserId: "8merwrSzZjRS9fEZWhmVjLY6fuk2",
      phoneNumber: "9554840740",
    },
    {
      label: "Nishant Singh",
      userId: "nish1997ns@gmail.com",
      appUserId: "gOiHHnBePCXIKIV8IBtNUClNN8H3",
      phoneNumber: "7007829243",
    },
    {
      label: "Sweta Kumari",
      userId: "kumarisweta.as@gmail.com",
      appUserId: "g8UburUl98Zj2G78fdZiVsmYeG43",
      phoneNumber: "8969963531",
    },
  ];

  const handleSend = async () => {
    if (type === "email") {
      await Notification.updateEmailTemplate(templateId, emailVariables).then(
        (res) => {}
      );

      await Notification.sendDolphinActionNotification(
        "email",
        templateId,
        selectedOption?.userId || customInput.userId,
        selectedOption?.appUserId || customInput.appUserId
      ).then((res) => {
        toast({
          position: "top",
          title: "Email Sent.",
          description: "Email is sent to the user successfully.",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
      });
    } else if (type === "whatsapp") {
      await Notification.updateWhatsappTemplate(
        templateId,
        whatsappImageUrl,
        whatsappVariables
      ).then((res) => {});

      await Notification.sendDolphinActionNotification(
        "whatsapp",
        templateId,
        selectedOption?.phoneNumber || customInput.phoneNumber
      ).then((res) => {
        // console.log(res.data);
        toast({
          position: "top",
          title: "Whatsapp Message Sent.",
          description: "Whatsapp Message is sent to the user successfully.",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
      });
    } else {
      await Notification.sendDolphinActionNotification(
        "notification",
        templateId,
        selectedOption?.appUserId || customInput.appUserId
      ).then((res) => {
        // console.log(res.data);
        toast({
          position: "top",
          title: "App Notification Sent.",
          description: "App Notification is sent to the user successfully.",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
      });
    }
  };

  const handleChange = (e: any) => {
    const selectedLabel = e.target.value;

    if (selectedLabel === "other") {
      setSelectedOption("other");
    } else {
      const selectedEmailOption = emailOptions.find(
        (opt) => opt.label === selectedLabel
      );

      if (selectedEmailOption) {
        setSelectedOption({
          userId: selectedEmailOption.userId,
          appUserId: selectedEmailOption.appUserId,
          phoneNumber: selectedEmailOption.phoneNumber,
        });
      } else {
        setSelectedOption(null);
      }
    }
  };

  const handleCustomInputChange = (e: any) => {
    setCustomInput({ ...customInput, [e.target.name]: e.target.value });
  };

  //   useEffect(() => {}, []);

  return (
    <>
      <Modal
        size="xl"
        initialFocusRef={initialRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.3)" />
        <ModalContent>
          <ModalHeader>Select Test User</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Select placeholder="Select option" onChange={handleChange}>
              {emailOptions.map((opt, index) => (
                <option key={index} value={opt.label}>
                  {opt.label}
                </option>
              ))}

              <option value="other">Other</option>
            </Select>

            {selectedOption && selectedOption !== "other" && (
              <div className="mt-4">
                <Text mt={4}>
                  <strong>Email:</strong> {selectedOption.userId}
                </Text>
                <Text>
                  <strong>AppUserId:</strong> {selectedOption.appUserId}
                </Text>
                <Text>
                  <strong>PhoneNumber:</strong> {selectedOption.phoneNumber}
                </Text>
              </div>
            )}

            {selectedOption === "other" && (
              <div className="mt-4">
                {type === "email" && (
                  <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input
                      name="userId"
                      placeholder="Enter UserId"
                      value={customInput.userId}
                      onChange={handleCustomInputChange}
                    />
                  </FormControl>
                )}

                {type !== "whatsapp" && (
                  <FormControl mt={2}>
                    <FormLabel>AppUserId</FormLabel>
                    <Input
                      name="appUserId"
                      placeholder="Enter AppUserId"
                      value={customInput.appUserId}
                      onChange={handleCustomInputChange}
                    />
                  </FormControl>
                )}

                {type === "whatsapp" && (
                  <FormControl mt={2}>
                    <FormLabel>Phone Number</FormLabel>
                    <Input
                      name="phoneNumber"
                      placeholder="Enter Phone Number"
                      value={customInput.phoneNumber}
                      onChange={handleCustomInputChange}
                    />
                  </FormControl>
                )}
              </div>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                handleSend();
                onClose();
              }}
            >
              Submit
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
